import React from 'react';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import MailIcon from '@mui/icons-material/Mail';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SettingsIcon from '@mui/icons-material/Settings';
import PeopleIcon from '@mui/icons-material/People';
import BusinessIcon from '@mui/icons-material/Business';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';

const MobileBottomNav = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useAuth();
    const { t } = useLanguage();

    const isAdmin = ['super_admin', 'org_admin', 'multi_org_admin'].includes(user?.role);

    const navItems = isAdmin ? [
        { label: t('layout.webmail'), icon: <MailIcon />, path: '/webmail' },
        { label: t('layout.dashboard'), icon: <DashboardIcon />, path: '/dashboard' },
        { label: t('layout.users'), icon: <PeopleIcon />, path: '/users' },
        { label: t('layout.organizations'), icon: <BusinessIcon />, path: '/organizations' },
        { label: t('layout.settings'), icon: <SettingsIcon />, path: '/settings' },
    ] : [
        { label: t('layout.webmail'), icon: <MailIcon />, path: '/webmail' },
        { label: t('layout.calendar'), icon: <CalendarMonthIcon />, path: '/calendar' },
        { label: t('layout.settings'), icon: <SettingsIcon />, path: '/settings' },
    ];

    const currentValue = navItems.findIndex(item => location.pathname.startsWith(item.path));

    return (
        <Paper
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1200,
                display: { xs: 'block', sm: 'none' },
                borderTop: '1px solid',
                borderColor: 'divider',
                pb: 'env(safe-area-inset-bottom, 0px)',
            }}
            elevation={8}
        >
            <BottomNavigation
                value={currentValue >= 0 ? currentValue : 0}
                onChange={(_, newValue) => navigate(navItems[newValue].path)}
                showLabels
                sx={{
                    height: 56,
                    '& .MuiBottomNavigationAction-root': {
                        minWidth: 'auto',
                        py: 0.5,
                        '& .MuiBottomNavigationAction-label': {
                            fontSize: '0.65rem',
                            '&.Mui-selected': { fontSize: '0.7rem' },
                        },
                    },
                }}
            >
                {navItems.map((item) => (
                    <BottomNavigationAction
                        key={item.path}
                        label={item.label}
                        icon={item.icon}
                    />
                ))}
            </BottomNavigation>
        </Paper>
    );
};

export default MobileBottomNav;
